import { Dispatch } from "redux";
import {
  ERROR_LOADING_SPECIES,
  GET_ALL_SPECIES,
  RESET_DATA,
  START_LOADING_SPECIES,
  STOP_LOADING_SPECIES,
} from "./action-types";
import apiLibrary from "services/api";
import { generateQueryStringForUsers } from "utils/convertFiltersToQueryString";
import { Toasts } from "view/components/Toasts";

export const fetchSpeciesAction =
  (communityId?: any) => async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: START_LOADING_SPECIES });
    try {
      const currentState = getState();
      const params = generateQueryStringForUsers(
        currentState.Filters.speciesFilter
      );

      const query = appendCommunityIdInParams(communityId, params);

      const { data } = await apiLibrary.SpeciesAndObjects.getAllSpecies(query);
      dispatch({
        type: GET_ALL_SPECIES,
        payload: data,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
      dispatch({
        type: RESET_DATA,
      });
      console.log("An error occurred while fetching the user profile:", error);
      dispatch({ type: ERROR_LOADING_SPECIES });
      // dispatch(fetchError(error))
    } finally {
      dispatch({ type: STOP_LOADING_SPECIES });
      // dispatch(loadingState(false))
    }
  };
const appendCommunityIdInParams = (communityId: any, params: any) => {
  let updatedParams = { ...params };

  if (communityId) {
    updatedParams.communityId = communityId.toString();
  }

  return updatedParams;
};
